<template>
  <BTable
    :headers="headers"
    :actions="actions"
    :list="list"
    :items-per-page-options="[25, 50, 100, 200]"
    class="BTableReportsRoadmapCommon"
  >
    <!--  -->

    <template #body="{ items }">
      <tbody>
        <tr v-if="items.length === 0">
          <td :colspan="headers.length" v-text="'Данные отсутсвуют'" />
        </tr>

        <template v-for="item in items">
          <tr v-if="item.type === 'direction'" :key="item.id">
            <td v-text="item.number" />
            <td :colspan="headers.length - 1" v-html="item.name" />
          </tr>

          <tr v-else :key="item.id">
            <td v-for="header in headers" :key="header.value">
              <RowEvent
                :name="header.value"
                :data="item[header.value]"
              />
            </td>
          </tr>
        </template>
      </tbody>
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import { TABLE_HEADERS } from './table-headers'
import BTable from '@/components/common/BTable.vue'
import RowEvent from './LKReportsRoadmapCommonTableRowEvent.vue'

export default {
  name: 'LKReportsRoadmapCommonTable',
  components: {
    BTable,
    RowEvent,
  },
  props: {
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
$border-color: rgba(0, 0, 0, 0.12);

.BTableReportsRoadmapCommon {
  th {
    color: $color-black !important;
    text-align: left;
    word-break: break-word;
    border-top: thin solid $border-color;
    border-left: thin solid $border-color;
  }

  tr:last-child td {
    border-bottom: thin solid $border-color;
  }

  // stylelint-disable-next-line no-descending-specificity, selector-list-comma-newline-after
  th, td {
    position: relative;
    height: auto !important;
    padding: 4px !important;
    font-size: 12px !important;
    border-left: thin solid $border-color;

    // stylelint-disable-next-line no-descending-specificity
    &:last-child {
      border-right: thin solid $border-color;
    }
  }
}
</style>
